import React, { useEffect, useState } from "react";
import AuthAPI from "../../api/admin/authApi";
import { showError } from "../../utils/toastUtils";
import { Link } from "react-router-dom";
import {
  useConstituencies,
  useStates,
} from "../../hooks/useStatesAndConstituencies";
import MpAPI from "../../api/admin/mpApi";
import useNumericInput from "../../hooks/useNumericInput";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../components/LanguageSwitcher";

function ForgotPassword() {
  const { t } = useTranslation();
  useNumericInput();
  useAlphabeticInput();

  const [email, setEmail] = useState("");

  const [errors, setErrors] = useState({});

  const [alert, setAlert] = useState("");

  const validate = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const newErrors = {};
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate()) {
      const payload = {
        email,
        key: "forgot_password",
      };

      try {
        const res = await MpAPI.store(payload);

        if (res.code === 200) {
          setAlert(
            "OTP Sent Successfully. Please wait for the approval from admin"
          );
        } else {
          showError(res.message);
        }
      } catch (err) {
        showError(err.response?.data?.message || "Change Password failed");
      }
    }
  };

  return (
    <div className="main-wrapper">
      <div className="overflow-hidden acc-vh">
        <div className="row vh-100 w-100 g-0">
          <div className="col-lg-6 vh-100 overflow-y-auto overflow-x-hidden">
            <div className="row">
              <div className="col-md-10 mx-auto">
                <div className="mt-2">
                  <LanguageSwitcher />
                </div>
                <form
                  method="post"
                  onSubmit={handleSubmit}
                  className="vh-100 d-flex justify-content-between flex-column p-4 pb-0"
                >
                  <div className="text-center auth-logo">
                    <Link to="/admin">
                      <img
                        src={`${process.env.PUBLIC_URL}/img/sansad-khel-mahotsav.webp`}
                        alt="logo"
                        style={{ width: 300, objectFit: "cover" }}
                      />
                    </Link>
                  </div>
                  <div>
                    <div className="mb-3">
                      <h3 className="mb-2">{t("forgot_password_title")}</h3>
                      <p className="mb-0">{t("forgot_password_subtitle")}</p>
                    </div>

                    {alert && (
                      <div
                        class="alert alert-warning text-bg-warning alert-dismissible"
                        role="alert"
                      >
                        <b>{alert}</b>
                        <button
                          type="button"
                          class="btn-close btn-close-white"
                          data-bs-dismiss="alert"
                          aria-label="Close"
                        ></button>
                      </div>
                    )}

                    <div className="mb-3">
                      <label className="form-label">{t("email")}</label>
                      <div className="input-group input-group-flat">
                        <input
                          type="email"
                          className="form-control"
                          autoComplete="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder={t("email")}
                        />
                        <span className="input-group-text border-start-0">
                          <i className="ti ti-mail" />
                        </span>
                      </div>
                      {errors.email && (
                        <span className="text-danger">{errors.email}</span>
                      )}
                    </div>

                    <div className="mb-3">
                      <button type="submit" className="btn btn-primary w-100">
                        {t("get_otp")}
                      </button>
                    </div>
                    <div class="mb-3">
                      <p class="mb-0">
                        <Link
                          to="/admin"
                          className="link-indigo fw-bold link-hover ms-1"
                        >
                          {t("return_to_login")}
                        </Link>
                      </p>
                    </div>
                  </div>
                  <div className="text-center pb-4">
                    <p className="text-dark mb-0">
                      Copyright © - Axepert Exhibits Pvt. Ltd.
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-lg-6 account-bg-01" />
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
